export function Divider({ mark = '✦' }: { mark?: string }) {
  return (
    <div className="divider" aria-hidden>
      <span className="divider__mark">{mark}</span>
    </div>
  );
}
